<div class="inspect-overlay" (click)="closed.emit()">
    <div class="inspect-panel" (click)="$event.stopPropagation()">

        <div class="inspect-header">
            <div class="inspect-title">
                <h2>{{ item.denominacion }}</h2>
                <span class="inspect-badge" [attr.data-cat]="item.categoria">
                    {{ getCategoriaLabel(item.categoria) }}
                </span>
            </div>
            <button class="inspect-close" (click)="closed.emit()">✕</button>
        </div>

        <div class="inspect-body">
            <table class="inspect-table">
                <tbody>
                    @for (entry of getEntries(); track entry[0]) {
                    <tr>
                        <td class="inspect-key">{{ entry[0] }}</td>
                        <td class="inspect-val">{{ entry[1] ?? '—' }}</td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="inspect-footer">
            <button class="inspect-close-btn" (click)="closed.emit()">Cerrar</button>
        </div>

    </div>
</div>
